import { render, staticRenderFns } from "./ERPCertificate.vue?vue&type=template&id=091380e2&scoped=true"
import script from "./ERPCertificate.vue?vue&type=script&lang=js"
export * from "./ERPCertificate.vue?vue&type=script&lang=js"
import style0 from "./ERPCertificate.vue?vue&type=style&index=0&id=091380e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091380e2",
  null
  
)

export default component.exports